import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { RestaurantAddress, OrderWithContext, OrderDeliveryInfo, OrderDeliveryInfoStatus } from '@/models';
import { FeedbackResponse } from '@/models/feedback';

const ORDER_INFO_POLL_RATE_MS = 60000;
const CONFIRMED = 'CONFIRMED';
const COMPLETED = 'COMPLETED';

@Component({
  name: 'CmgOrderConfirmationHeader',
})
export default class CmgOrderConfirmationHeader extends Vue {
  refreshOrderStatusInterval: number | null = null;
  orderComplete = false;
  isRatingStarHoverState = false;
  isRatingButtonActive = false;

  @Prop({ required: true, type: Object })
  order!: OrderWithContext;

  @Prop({ required: true, type: Object })
  address!: RestaurantAddress;

  @Prop({ required: true, type: Boolean })
  isPickup!: boolean;

  @Prop({ required: false, type: Object })
  deliveryInfo?: OrderDeliveryInfo;

  mounted() {
    this.$services.ui.nextFocus('pickup-order-status');
    this.refreshOrderStatus();
    this.$services.ui.nextFocus('orderStatus');
    this.refreshOrderStatusInterval = window.setInterval(() => this.refreshOrderStatus(), ORDER_INFO_POLL_RATE_MS);
  }

  beforeDestroy() {
    this.clearRefreshOrderStatusInterval();
  }

  get pickupTime(): string | null {
    return this.order.order.pickupDateTimeLocal || null;
  }

  get arrivalTime(): string | null {
    return this.$store.state.order.pendingOrderDeliveryInfo.quotedDeliveryTime;
  }

  get deliveryBackgroundImageUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.ingredientsPattern.default;
  }

  get orderStatus(): string {
    return this.orderComplete ? COMPLETED : CONFIRMED;
  }

  get ratingStar(): string {
    if (this.isRatingButtonActive) {
      return this.$appStore.state.cms.images.icons.ratingStarDark.default;
    }

    return this.isRatingStarHoverState ? this.$appStore.state.cms.images.icons.ratingStarLightBrown.default : this.$appStore.state.cms.images.icons.ratingStarBrown.default;
  }

  get feedback(): FeedbackResponse | null {
    return this.$appStore.state.order.feedback;
  }

  refreshOrderStatus(): void {
    let completed = false;

    if (this.isPickup) {
      const now = moment();
      completed = moment(this.order.order.pickupDateTimeLocal) <= now;
    } else if (this.deliveryInfo) {
      completed = this.deliveryInfo.deliveryStatus == OrderDeliveryInfoStatus.Delivered;
    }

    // clear refresh interval once order is completed.
    if (completed) {
      this.clearRefreshOrderStatusInterval();
    }

    this.orderComplete = completed;
  }

  clearRefreshOrderStatusInterval(): void {
    if (this.refreshOrderStatusInterval != null) {
      window.clearInterval(this.refreshOrderStatusInterval);
    }
  }

  getDate(time: string) {
    return moment(time).format('MMMM DD, YYYY');
  }

  getTime(time: string) {
    return moment(time).format('hh:mm');
  }

  getPeriod(time: string) {
    return moment(time).format('A');
  }

  onMouseEnterRatingButton(): void {
    this.isRatingStarHoverState = true;
  }

  onMouseLeaveRatingButton(): void {
    this.isRatingStarHoverState = false;
  }

  onMouseUpRatingButton(): void {
    this.isRatingButtonActive = false;
  }

  onMouseDownRatingButton(): void {
    this.isRatingButtonActive = true;
  }

  onClickRate(event: Event) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('feedback', true);
  }
}
